export const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:8000/api/').replace(/\/?$/, '/');
const baseUrl = `${API_URL}admin`;
const APP_URL = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;

export default APP_URL;
